import { observer } from 'mobx-react-lite'
import React from 'react'
import useStore from 'reusable/mobx-store-utils'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { useParams } from 'react-router-dom'
import useQuery from 'reusable/hooks/useQuery'
import { useRegionRouterStore } from 'features/main/RegionRouterStore'
import { notNull } from '@gap/utils/utils'
import { useAuthStore } from 'auth/AuthStore'
import { PlatformContainer } from 'reusable/containers/PlatformContainer'
import AuthValidateCustomTokenStore from './AuthValidateCustomTokenStore'
import AuthEmailLinkExpired from './AuthEmailLinkExpired'

interface AuthValidateCustomTokenParams {
   attemptSignIn: boolean
}

export default observer(function AuthValidateCustomToken({ attemptSignIn }: AuthValidateCustomTokenParams) {
   const { token, userId } = useParams()
   const queryString = useQuery()
   const authStore = useAuthStore()
   const regionRouterStore = useRegionRouterStore()

   const authValidateCustomTokenStore = useStore((sp) => new AuthValidateCustomTokenStore(sp), {
      authStore,
      token: notNull(token),
      userId: notNull(userId),
      redirectUrl: notNull(queryString.get('redirectUrl')),
      regionRouterStore,
      attemptSignIn
   })

   useInitialMount(async () => {
      await authValidateCustomTokenStore.validateTokenAndRedirect()
   })

   if (authValidateCustomTokenStore.displayExpiredLink) {
      return <PlatformContainer contentCentered={true}>
         <AuthEmailLinkExpired canRenewLink={authValidateCustomTokenStore.canRenewLink} />
      </PlatformContainer>
   }

   return <PlatformContainer loadingMessage="Validating request" loading={true} contentCentered={true} />
})
